import { getFlixTldFromHostname } from 'app/functions';
import { recentCitiesCookieSelector, recentCitiesSelector } from 'app/store/selectors';
import { setCookie } from 'app/storage/coookie';
import { AppDispatch, RootState } from 'app/hooks/appHooks';
import { AutocompleteResult, SearchMaskDirection } from 'app/models/types/store/location';
import { retrieveRecentCities } from './retrieveRecentCitiesThunk';
import { createAsyncThunk } from '@reduxjs/toolkit';

export type StoreRecentCityType = {
  direction: SearchMaskDirection;
  city: Pick<AutocompleteResult, 'id' | 'name' | 'legacyId'>;
};

export const storeRecentCity = createAsyncThunk<
  void,
  StoreRecentCityType,
  {
    dispatch: AppDispatch;
    state: RootState;
  }
>('location/retrieveRecentCities', async ({ direction, city }, { dispatch, getState }) => {
  const state = getState();
  const domain = getFlixTldFromHostname(document.location.hostname) || document.location.hostname;
  const cookies: { from: string; to: string } = recentCitiesCookieSelector(state);
  const recentCities: ReturnType<typeof recentCitiesSelector> = recentCitiesSelector(state);
  const newCities = [
    { id: city.id, name: city.name },
    ...recentCities[direction]
      .filter(({ id }) => id !== city.id)
      .map(({ id, name }) => ({ id, name })),
  ];
  setCookie(cookies[direction], JSON.stringify(newCities.slice(0, 5)), { domain, expires: 365 });

  await dispatch(retrieveRecentCities());
});
